// Voice ids accepted by the Kokoro TTS server. The prefix encodes accent and
// gender: a = American, b = British, f = female, m = male.
//
// Kokoro does not reject an unknown voice, it quietly falls back to its own
// default, so only names from this list produce the voice that was picked.
const kokoroVoices = [
  'af_heart',
  'af_alloy',
  'af_aoede',
  'af_bella',
  'af_jessica',
  'af_kore',
  'af_nicole',
  'af_nova',
  'af_river',
  'af_sarah',
  'af_sky',
  'am_adam',
  'am_echo',
  'am_eric',
  'am_fenrir',
  'am_liam',
  'am_michael',
  'am_onyx',
  'am_puck',
  'am_santa',
  'bf_alice',
  'bf_emma',
  'bf_isabella',
  'bf_lily',
  'bm_daniel',
  'bm_fable',
  'bm_george',
  'bm_lewis',
]

export default kokoroVoices
